import { render, staticRenderFns } from "./CustomerCardNotes.vue?vue&type=template&id=0001c6a1&scoped=true"
import script from "./CustomerCardNotes.vue?vue&type=script&lang=ts"
export * from "./CustomerCardNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001c6a1",
  null
  
)

export default component.exports